<template>
  <transition name="fade">
    <v-container>
      <v-card>
        <v-card-text>
          <v-overlay :value="loader">
            <v-progress-circular indeterminate size="50"></v-progress-circular>
            <span class="ml-3">Cargando</span>
          </v-overlay>

          <v-form @submit.prevent="checkForm">
            <v-label>
              Indica el número de factura que se asignará a los
              {{ ids.length }} productos seleccionados
            </v-label>
            <v-alert v-if="errors.n_factura" type="error" dense outlined>
              {{ errors.n_factura }}
            </v-alert>

            <v-row>
              <v-col cols="12">
                <v-label>Facturas en este documento:</v-label>
                <v-chip-group>
                  <v-chip
                    v-for="(fact, index) in facturasDocument"
                    :key="index"
                    color="blue"
                    outlined
                    @click="selectExistFactura(fact)"
                  >
                    {{ fact.Nombre }} - {{ fact.ProvNombre }}
                  </v-chip>
                </v-chip-group>
              </v-col>

              <v-col cols="12" md="6">
                <v-label>Selecciona el proveedor para buscar facturas</v-label>
                <v-alert v-if="errors.factura" type="error" dense outlined>
                  {{ errors.factura }}
                </v-alert>
                <v-autocomplete
                  v-model="provedorSearch"
                  :items="comp_proveedor"
                  @update:search="searchProv"
                  label="Seleccione un proveedor para buscar facturas"
                  placeholder="Seleccione un proveedor"
                  dense
                  outlined
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="6">
                <v-label>Factura</v-label>
                <v-alert v-if="errors.factura" type="error" dense outlined>
                  {{ errors.factura }}
                </v-alert>
                <v-autocomplete
                  v-model="n_factura"
                  :items="comp_fact"
                  @change="onSelectProv"
                  label="Seleccione una factura del listado"
                  placeholder="Seleccione una factura"
                  dense
                  outlined
                ></v-autocomplete>
              </v-col>

              <v-col cols="12">
                <v-label>¿No encuentras tu factura? {{ searchText }}</v-label>
                <v-btn
                  color="primary"
                  small
                  @click="
                    keyformFactura++;
                    showModalFactura = true;
                  "
                >
                  Agregar
                </v-btn>
              </v-col>
            </v-row>

            <modal
              v-model="showModalFactura"
              :showFooter="false"
              title="Agregar nueva factura"
            >
              <FacturaForm
                :key="keyformFactura"
                @successData="saveFactura"
                @toggle="showModalFactura = false"
              ></FacturaForm>
            </modal>

            <v-row justify="end">
              <v-btn color="error" class="mr-2" @click="$emit('toggle', false)">
                Cancelar
              </v-btn>
              <v-btn color="success" type="submit"> Guardar </v-btn>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-container>

    <!-- <div v-if="false" class="ui card fluid">
      <div class="content">
        <div v-show="loader" class="ui active dimmer">
          <div class="ui text loader">Cargando</div>
        </div>
        <div class="description">
          <form class="ui form" @submit="checkForm">
            <label
              >Indica el numero de factura que se asignara a los
              {{ ids.length }} productos seleccionados
              <div
                v-if="errors.n_factura"
                class="ui left pointing red basic label"
              >
                {{ errors.n_factura }}
              </div>
            </label>
            <div class="field">
              <div class="field">
                <label
                  >Facturas en este documento: (Puedes seleccionar una de las
                  facturas registradas en el documento o buscar otra)
                </label>
                <template v-for="(fact, index) in facturasDocument">
                  <a
                    href="javascript:void(0);"
                    @click="selectExistFactura(fact)"
                    :key="index"
                    class="ui blue label"
                    >{{ fact.Nombre }} - {{ fact.ProvNombre }}</a
                  >
                </template>
              </div>
            </div>
            <div class="field">
              <div class="field required">
                <label
                  >Selecciona el proveedor para buscar facturas
                  <div
                    v-if="errors.factura"
                    class="ui left pointing red basic label"
                  >
                    {{ errors.factura }}
                  </div>
                </label>
                <model-select
                  :options="comp_proveedor"
                  v-model="provedorSearch"
                  @searchchange="searchProv"
                  placeholder="Seleccione un proveedor para buscar facturas"
                >
                </model-select>
              </div>
            </div>
            <div class="field two fields">
              <div class="field required">
                <label
                  >Factura
                  <div
                    v-if="errors.factura"
                    class="ui left pointing red basic label"
                  >
                    {{ errors.factura }}
                  </div>
                </label>
                <model-select
                  :options="comp_fact"
                  v-model="n_factura"
                  @select="onSelectProv"
                  placeholder="Seleccione una factura del listado"
                >
                </model-select>
              </div>
              <div class="field">
                <label>¿No encuentras tu factura? {{ searchText }} </label>
                <button
                  type="button"
                  @click="
                    keyformFactura++;
                    showModalFactura = true;
                  "
                  class="ui primary tiny button"
                >
                  Agregar
                </button>
              </div>
            </div>

            <modal
              v-model="showModalFactura"
              :showFooter="false"
              title="Agregar nueva factura"
            >
              <FacturaForm
                :key="keyformFactura"
                @successData="saveFactura"
                @toggle="showModalFactura = false"
              ></FacturaForm>
            </modal>

            <button
              style="float: right"
              class="ui button positive"
              type="submit"
            >
              Guardar
            </button>
            <button
              style="float: right"
              @click="$emit('toggle', false)"
              class="ui button"
              type="button"
            >
              Cancelar
            </button>
          </form>
        </div>
      </div>
    </div> -->
  </transition>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<script>
import moment from "moment";
import modal from "../../MainComponents/modal.vue";
import { ModelSelect } from "vue-search-select";
import FacturaForm from "../../Inventarios/RecepcionMercancias/FacturaForm.vue";

export default {
  name: "ProductNumeroFacturaForm",
  components: {
    // ModelSelect,
    FacturaForm,
    modal,
  },
  props: ["edit", "dataEdit", "ids", "facturasDocument"],
  data() {
    return {
      keyformFactura: 1,
      showModalFactura: false,
      provedorSearch: "",
      searchText: "",
      n_factura: "",
      facturaNombre: "",
      proveedorNombre: "",
      facturasArray: [],
      proveedorArray: [],
      idRow: [],
      errors: {},
      loader: true,
    };
  },
  methods: {
    selectExistFactura(data) {
      this.facturasArray = [{ id: data.Id, Nombre: data.Nombre }];
      this.proveedorArray = [{ id: data.ProvId, Nombre: data.ProvNombre }];
      this.n_factura = data.Id;
      this.provedorSearch = data.ProvId;
    },
    async searchProv(searchText) {
      if (searchText != "") {
        this.proveedorArray = [];
        let text = searchText.toUpperCase();

        const data = await this.$store.getters.getFirebaseApp.database
          .ref("AMC/Provedores")
          .orderByChild("NAME~~RFC")
          .startAt(text)
          .endAt(text + "\uf8ff")
          .once("value");
        if (data.exists()) {
          let arrayFactura = Object.entries(data.val());
          this.$pgsHelper.log(arrayFactura);
          arrayFactura.forEach((element) => {
            this.proveedorArray.push({
              id: element[0],
              Nombre: element[1]["nom"],
            });
          });
        }
      }
    },
    async onSelectProv(item) {
      if (item != "") {
        this.facturasArray = [];
        let searchText = item.toUpperCase();

        const data = await this.$store.getters.getFirebaseApp.database
          .ref("PDV/Productos/Facturas")
          .orderByChild("PVDR_ID~~PVDR_NAME~~NAME")
          .startAt(searchText)
          .endAt(searchText + "\uf8ff")
          .once("value");
        if (data.exists()) {
          let arrayFactura = Object.entries(data.val());
          this.$pgsHelper.log(arrayFactura);
          arrayFactura.forEach((element) => {
            this.facturasArray.push({
              id: element[0],
              Nombre: element[1]["Nombre"],
              Proveedor: element[1]["ProvNombre"],
            });
          });
        }
      }
    },
    async searchProveedor(searchText) {
      if (searchText != "") {
        this.facturasArray = [];
        searchText = searchText.toUpperCase();
        this.$pgsHelper.log(searchText);
        const data = await this.$store.getters.getFirebaseApp.database
          .ref("PDV/Productos/Facturas")
          .orderByChild("NAME~~PVDR_NAME~~PVDR_ID")
          .startAt(searchText)
          .endAt(searchText + "\uf8ff")
          .once("value");
        if (data.exists()) {
          let arrayFactura = Object.entries(data.val());
          this.$pgsHelper.log(arrayFactura);
          arrayFactura.forEach((element) => {
            this.facturasArray.push({
              id: element[0],
              Nombre: element[1]["Nombre"],
              Proveedor: element[1]["ProvNombre"],
            });
          });
        }
      }

      /*let categorias = [];
        arrayCate.forEach(function(element){
            categorias.push({id:element[0],Nombre:element[1]['Nombre']}); 
        });
        this.Categories = categorias;*/
      //CONF/Catalogo/PDV/Productos/Facturas
    },
    checkForm: function (e) {
      e.preventDefault();
      let valid = true;

      this.errors = [];

      if (!this.n_factura) {
        this.errors.n_factura = "El numero de factura es obligatorio";
        valid = false;
      } else {
        this.errors.n_factura = false;
      }

      /*
        if (!this.HoraFinal) {
            this.errors.hfinal = 'La hora final es requerida';
            valid = false;
        }else{
            this.errors.hfinal = false;
        }*/

      if (valid) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }

        this.facturasArray.forEach((element) => {
          if (element.id == this.n_factura) {
            this.facturaNombre = element.Nombre;
          }
        });

        this.proveedorArray.forEach((element) => {
          if (element.id == this.provedorSearch) {
            this.proveedorNombre = element.Nombre;
          }
        });
        this.$emit("successData", this.$data, doAction);
      }
    },
    saveFactura(datos) {
      let sendData = {
        Nombre: datos.factura,
        ProvId: datos.proveedor,
        ProvNombre: datos.proveedorNombre,
        Creacion: new moment().format("YYYY-MM-DD"),
      };
      this.$pgsHelper.log(sendData);
      this.$swal({
        title: "¿Deseas crear esta nueva factura?",
        text: "Se registrar la factura con los datos indicados ",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Productos-createFactura", sendData)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "La factura se guardo corretamente",
              icon: "success",
            });

            this.showModalFactura = false;
          } else {
            this.$swal(
              "Error saving Categoria",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
  },
  computed: {
    comp_fact() {
      let fact = [];
      this.facturasArray.forEach((element) => {
        fact.push({
          value: element.id,
          text: element.Nombre + " - " + element.Proveedor,
        });
      });

      return fact;
    },

    comp_proveedor() {
      let prov = [];
      this.proveedorArray.forEach((element) => {
        prov.push({ value: element.id, text: element.Nombre });
      });

      return prov;
    },
  },
  watch: {
    provedorSearch: function (val) {
      this.onSelectProv(val);
    },
  },
  beforeMount: function () {},
  mounted() {
    this.loader = false;
    this.idRow = this.ids;
    if (this.edit) {
      this.nombre = this.dataEdit.Nombre;
    }
  },
};
</script>
